export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--I.7ee11939.png";